import { FeatureFlagStorageKeys, StorageKeys } from '@constants/storageKeys';
import useFetchVersion from './useFetchVersion';
import { isLocalFeatureFlagEnabled } from '@utils/featureFlags';
import { useEffect } from 'react';
import useSentry from '@components/features/sentry/hooks/useSentry';

const useFeatureFlags = () => {
    const { data: versionInfo } = useFetchVersion();
    const { setSentryTag } = useSentry();

    const isFeatureFlagEnabled = (featureFlag: FeatureFlagStorageKeys): boolean => {
        if (!versionInfo) return false;

        const normalizedTenantFeatureFlags = Object.fromEntries(Object.entries(versionInfo?.featureFlags || {}).map(([key, value]) => [key.toLowerCase(), value]));
        const tenantFeatureFlagValue = normalizedTenantFeatureFlags?.[featureFlag.toLowerCase()];

        // if not defined from configuration, check local storage
        if (tenantFeatureFlagValue === undefined || tenantFeatureFlagValue === null) {
            return isLocalFeatureFlagEnabled(featureFlag);
        } else {
            return tenantFeatureFlagValue === true;
        }
    };

    const featureFlags = {
        featureFlagTemplateSharing: isFeatureFlagEnabled(StorageKeys.TemplateSharing),
        featureFlagTemplateSharingManagement: isFeatureFlagEnabled(StorageKeys.TemplateSharingManagement),
        featureFlagSamDebug: isFeatureFlagEnabled(StorageKeys.SamDebug),
        featureFlagCachedLookups: true,
        featureFlagFileHandlerMultipleDocClasses: isFeatureFlagEnabled(StorageKeys.FileHandlerMultipleDocClasses),
        featureFlagLinkDocuments: isFeatureFlagEnabled(StorageKeys.LinkDocuments),
        featureFlagUseStrictDevicePixelRatio: isFeatureFlagEnabled(StorageKeys.UseStrictDevicePixelRatio),
        featureFlagMatomoDataLake: true,
        featureFlagTestDocumentIndicator: isFeatureFlagEnabled(StorageKeys.TestDocumentIndicator),
        featureFlagSamBackOfficeStatusHelper: isFeatureFlagEnabled(StorageKeys.SamBackOfficeStatusHelper),
    };

    useEffect(() => {
        for (const [key, value] of Object.entries(featureFlags)) {
            setSentryTag(key, value);
        }
    }, [featureFlags]);

    return featureFlags;
};

export default useFeatureFlags;
